import {SideReelFeature} from "./SideReelFeature";
import {gsap} from "gsap";
import {AnimUtils} from "../../../../utils/AnimUtils";
import {FeatureList, GameConfig} from "../../../../GameConfig";
import {ISymbol} from "../../../../../core/reel/IReelData";
import {HOTB} from "../../../../HOTB";
import {GameSymbol, SymbolsList, SymbolStates} from "../../../../reels/GameSymbol";
import {GameSounds} from "../../../../sound/GameSounds";
import {HOTBData} from "../../../../server/HOTBData";

export class XSplitFeature extends SideReelFeature {
    constructor(rowId: number, whichSide: string, featureName: string) {
        super(rowId, whichSide, featureName);
    }

    public startSplit(isFirstSplitFeature: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            finalPosX: number = (this.side === "left") ? 570 : 150,
            triggerStartAnim: string = "4_triggerStart",
            triggerStartDuration: number = AnimUtils.getSpineDuration(this._spine, triggerStartAnim),
            triggerEndAnim: string = "5_triggerEnd";

        tl.add([
            this.playAnimation(triggerStartAnim),
            gsap.to(this.position, {
                x: finalPosX,
                duration: triggerStartDuration
            }),
            (): void => {
                HOTB.soundPlayer.playSideReelFeatureSounds(GameSounds.SPLIT_START);
            }
        ]);

        tl.add([
            this.playAnimation(triggerEndAnim),
            (): void => {
                if (isFirstSplitFeature) {
                    const hotbData: HOTBData = HOTB.model.data,
                        reelLeftData: string[] = hotbData.reelLeft,
                        reelRightData: string[] = hotbData.reelRight,
                        totalSplitFeatures: number = [...reelLeftData, ...reelRightData].reduce((count, item) => {
                            return item === FeatureList.XSPLIT ? count + 1 : count;
                        }, 0);

                    AnimUtils.startVibrate(totalSplitFeatures);
                    HOTB.soundPlayer.playSideReelFeatureSounds(GameSounds.SPLIT_END);
                }
            }
        ]);

        if (this.side === "left") {
            for (let reelId: number = 0; reelId < GameConfig.totalReels; reelId++) {
                tl.add(this.doTheSplit(reelId), (0.025 + (reelId * 0.06)));
            }
            tl.add((): void => {
                HOTB.waysCounter.updateWaysCounterFromXSplit(this.rowId);
            }, 0.25);
        } else {
            let counter: number = 0;

            for (let reelId: number = (GameConfig.totalReels - 1); reelId >= 0; reelId--) {
                tl.add(this.doTheSplit(reelId), (0.025 + (counter * 0.06)));
                counter++;
            }
            tl.add((): void => {
                HOTB.waysCounter.updateWaysCounterFromXSplit(this.rowId);
            }, 0.25);
        }

        return tl;
    }

    private doTheSplit(reelId: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add((): void => {
            const currSymbol: ISymbol = HOTB.reelArea.getSymbolAtPosition(reelId, this.rowId),
                currSplitCount: number = (<GameSymbol>currSymbol).splitCount,
                hotbData: HOTBData = HOTB.model.data;

            if ((<GameSymbol>currSymbol).symbolName === SymbolsList.XNUDGE) {
                HOTB.reelArea.mainReelModels[reelId].reelView.splitNudgeSymbols();
            } else {
                (<GameSymbol>currSymbol).splitCount = currSplitCount + 2;
                (<GameSymbol>currSymbol).getStateAnimation(SymbolStates.NORMAL);
                (<GameSymbol>currSymbol).updateSymbolMultiplier(hotbData.symbolSizes[reelId][this.rowId]);
            }
        });

        return tl;
    }
}